import { useCurrentUser } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useCallback } from "react";
import { downloadFile } from "../../components/OverviewTable/downloadFIle";
import { getDesignControlsBaseURL } from "../../api/apiConfig";

export const useDownloadTraceability = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  const download = useCallback(() => {
    downloadFile(
      `${getDesignControlsBaseURL()}/company/${companyId}/product-development/product/${productId}/download`,
    );
  }, [companyId, productId]);

  return {
    onDownloadFile: download,
  };
};
